import { Errors } from 'gleblu-socket-api';
import { createAction } from 'redux-act';

export interface ChangePasswordPayload {
  oldPassword: string;
  newPassword: string;
}
export const changePassword = createAction<ChangePasswordPayload>('CHANGE_PASSWORD');

export const passwordChanged = createAction<object>('PASSWORD_CHANGED');

export interface PasswordChangeFailedPayload {
  errorType?: Errors;
}
export const passwordChangeFailed = createAction<PasswordChangeFailedPayload>('PASSWORD_CHANGE_FAILED');
